<template>
  <router-view />
</template>

<script>
export default {
  name: 'FullScreenLayout'
};
</script>

<style scoped></style>
